<ng-container *ngIf="selectedLogType">
  {{ selectedLogType.title }}
</ng-container>
